
<div class="login u-bg-color-default u-default-shadow u-default-radius p-5">
	<div class="logo mb-5">
		<img src="assets/images/splash_screen.png" alt="">
	</div>

	<div class="login-footer">
		<button class="btn btn-alt md" (click)="login()">
			<span>Login</span>
		</button>
	</div>
<div>

